export function isEmptyMolecule(molecule) {
    return molecule.getAllAtoms() < 1;
}
//# sourceMappingURL=isEmptyMolecule.js.map